import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { SingupComponent } from './pages/singup/singup.component';
import { HomeComponent } from './pages/home/home.component';
import { HeaderComponent } from './pages/header/header.component';
import { FooterComponent } from './pages/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SwiperModule } from 'swiper/angular';
import { CategoryComponent } from './pages/category/category.component';
import { ProductsComponent } from './pages/products/products.component';
import { ProductsDetailsComponent } from './pages/products-details/products-details.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { PackgesComponent } from './pages/packges/packges.component';
import { PackgeDetailsComponent } from './pages/packge-details/packge-details.component';
import { AboutComponent } from './pages/about/about.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ToastrModule } from 'ngx-toastr';
import { ShopCartComponent } from './pages/shop-cart/shop-cart.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UpdataClientComponent } from './pages/updata-client/updata-client.component';
import { AddresComponent } from './pages/addres/addres.component';
import { ShopComponent } from './pages/shop/shop.component';
import { ForgetpwComponent } from './pages/forgetpw/forgetpw.component';
import { ResetpwComponent } from './pages/resetpw/resetpw.component';
import { UpdateMoreInfoComponent } from './pages/update-more-info/update-more-info.component';
import {
  FacebookLoginProvider,
  SocialLoginModule,
  SocialAuthServiceConfig,
} from '@abacritt/angularx-social-login';
import { RequestProductComponent } from './pages/request-product/request-product.component';
import { SearchComponent } from './pages/search/search.component';
import { SearchResultComponent } from './pages/search-result/search-result.component';
import { AddresInfoComponent } from './pages/addres-info/addres-info.component';
import { BlogsComponent } from './pages/blogs/blogs.component';
import { BlogDetailsComponent } from './pages/blog-details/blog-details.component';
import { ChooseAriaComponent } from './pages/choose-aria/choose-aria.component';
import { MatSelectModule } from '@angular/material/select';
import { CancelConfirmComponent } from './pages/cancel-confirm/cancel-confirm.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { EditOrderComponent } from './pages/edit-order/edit-order.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { PreventSpaceDirective } from './directives/PreventSpaceDirective.directive';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SingupComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    CategoryComponent,
    ProductsComponent,
    ProductsDetailsComponent,
    UserProfileComponent,
    PackgesComponent,
    PackgeDetailsComponent,
    AboutComponent,
    ShopCartComponent,
    UpdataClientComponent,
    AddresComponent,
    ShopComponent,
    ForgetpwComponent,
    ResetpwComponent,
    UpdateMoreInfoComponent,
    RequestProductComponent,
    SearchComponent,
    SearchResultComponent,
    AddresInfoComponent,
    BlogsComponent,
    BlogDetailsComponent,
    ChooseAriaComponent,
    CancelConfirmComponent,
    EditOrderComponent,
    TruncatePipe,
    TranslatePipe,
    PreventSpaceDirective,
    DashboardComponent,
    WishlistComponent,
    CustomToastComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    SocialLoginModule,
    MatSelectModule,
    NgxPaginationModule,
    ToastrModule.forRoot({
      toastComponent: CustomToastComponent,
      positionClass: 'toast-top-right',
      timeOut: 4000,
      progressBar: true,
      maxOpened: 5,
      autoDismiss: true,
      tapToDismiss: true,
      newestOnTop: true,
      preventDuplicates: true,
    }),
    ReactiveFormsModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('6209397375779362'),
          },
        ],
      } as SocialAuthServiceConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
